/* eslint-disable @typescript-eslint/no-explicit-any */
/* Trainee / Intern — Compensation & period. Total contract value is derived
   (stipend × months) and shown read-only. Maps to the entity's part-time
   fields: partTimeMonthlyPayout, partTimePeriod, partTimeContractValue. */
import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "components/Input";
import { preventSpecialCharKeyDown } from "util/preventSpecialCharInput";
import { SectionCard, FieldLabel } from "./_controls";
import { formatINR } from "../salaryStructure.calc";

const TraineeCompensationSection = () => {
  const { watch } = useFormContext();
  const stipend = Number(watch("monthlyStipend")) || 0;
  const months = Number(watch("periodMonths")) || 0;

  return (
    <SectionCard title="Compensation" subtitle="Stipend-based compensation and training period.">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
        <Input
          compact
          name="monthlyStipend"
          label="Monthly Stipend  ·  ₹ / month"
          type="number"
          required
          onKeyDown={preventSpecialCharKeyDown}
        />
        <Input
          compact
          name="periodMonths"
          label="Training Period  ·  months"
          type="number"
          required
          onKeyDown={preventSpecialCharKeyDown}
        />

        {/* Derived total contract value */}
        <div>
          <FieldLabel label="Total Contract Value" />
          <div className="flex items-center rounded-lg border border-slate-200 bg-slate-50 px-3 h-[42px] text-sm font-semibold text-slate-600 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200">
            {stipend && months ? formatINR(stipend * months) : "—"}
          </div>
        </div>
      </div>
    </SectionCard>
  );
};

export default TraineeCompensationSection;
